import React from "react";
import Navbar from "../components/Navbar";
import Jumbotron from "../components/Jumbotron";
import ChiSiamo from "../components/ChiSiamo";
import Servizi from "../components/Servizi";
import Contatti from "../components/Contatti";
import Footer from "../components/Footer";
import CookieConsent from "../components/CookieConsent";
import "@fontsource/chivo";
import "@fontsource/dancing-script/400.css";

const Home = () => {
  return (
    <div className="w-full min-h-screen overflow-x-hidden bg-white">
      <Navbar />
      <Jumbotron />
      <ChiSiamo />
      <Servizi />
      <Contatti />
      <Footer />
      <CookieConsent />
    </div>
  );
};

export default Home;
